module.exports = __webpack_public_path__ + "videos/gestures_jp.cdd97cb.mp4";